import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=7077177e&"
import script from "./DetailsModal.vue?vue&type=script&lang=js&"
export * from "./DetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports